export const RISK_LEVEL_HIGH = 'Alto';
export const RISK_LEVEL_MEDIUM = 'Medio';
